module.exports = __webpack_public_path__ + "img/works_ibk_btm_off_m.c3cfd2e9.png";